import { render, staticRenderFns } from "./CommonColorSelect.vue?vue&type=template&id=74f18bc8&scoped=true"
import script from "./CommonColorSelect.vue?vue&type=script&lang=js"
export * from "./CommonColorSelect.vue?vue&type=script&lang=js"
import style0 from "./CommonColorSelect.vue?vue&type=style&index=0&id=74f18bc8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f18bc8",
  null
  
)

/* custom blocks */
import block0 from "@/components/Common/locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Fstv%2FPycharmProjects%2FcomponentDB%2Fvueapp%2Fsrc%2Fcomponents%2FCommon%2FCommonColorSelect.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports